// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"SidepanelNav__NavigationItems__2uKk0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SidepanelNav/SidepanelNav.css
// module id = 115
// module chunks = 3